import React from "react";
import ConfidenceLabel from "../../shared/ConfidenceLabel";

const TabStatut = ({ form, onChange, getConfidence }) => {
  const gc = getConfidence || (() => ({ exists: false }));
  return (
    <div className="dn-fields">

      <div className="dn-field-group">
        <label>Statut <ConfidenceLabel confidence={gc("statut")} /></label>
        <div className="dn-radio-group">
          {["vivant", "decede", "abandon", "perdu_de_vue"].map((val) => (
            <label key={val} className="dn-radio-label">
              <input type="radio" name="statut" value={val}
                checked={form.statut === val}
                onChange={() => {
                    onChange("statut", val);
                    if (val !== "decede") onChange("date_deces", "");
                }} />
              {val === "vivant"      ? "Vivant"       :
               val === "decede"      ? "Décédé"       :
               val === "abandon"     ? "Abandon"      : "Perdu de vue"}
            </label>
          ))}
        </div>
      </div>

      {/* ── Si vivant ── */}
      {form.statut === "vivant" && (
        <div className="dn-sub-section">
          <div className="dn-section-label">Si vivant</div>
          <div className="dn-checkboxes">
            {[["vivant_rc1","RC1"],["vivant_rc2","RC2"],["vivant_autre","Autre"]].map(([key, label]) => (
              <label key={key} className="dn-checkbox-label">
                <input type="checkbox" checked={form[key] === true}
                  onChange={(e) => onChange(key, e.target.checked)} />
                {label}
                <ConfidenceLabel confidence={gc(key)} />
              </label>
            ))}
          </div>
          {form.vivant_autre && (
            <div className="dn-field-group">
              <label>Préciser <ConfidenceLabel confidence={gc("vivant_autre_preciser")} /></label>
              <input type="text" placeholder="Préciser..."
                value={form.vivant_autre_preciser ?? ""}
                onChange={(e) => onChange("vivant_autre_preciser", e.target.value)}
                style={{ borderColor: gc("vivant_autre_preciser").color || undefined }} />
            </div>
          )}
        </div>
      )}

      {/* ── Si décédé ── */}
      {form.statut === "decede" && (
        <div className="dn-sub-section">
            <div className="dn-field-group">
                <label>Date de décès <ConfidenceLabel confidence={gc("date_deces")} /></label>
                <input type="date" value={form.date_deces ?? ""}
                    onChange={(e) => onChange("date_deces", e.target.value)}
                    style={{ borderColor: gc("date_deces").color || undefined }} />
            </div>
          <div className="dn-section-label">Cause du décès</div>
          <div className="dn-checkboxes">
            {[
              ["decede_cancer",       "Cancer"],
              ["decede_complication", "Complication thérapeutique"],
              ["decede_autre",        "Autre cause"],
            ].map(([key, label]) => (
              <label key={key} className="dn-checkbox-label">
                <input type="checkbox" checked={form[key] === true}
                  onChange={(e) => onChange(key, e.target.checked)} />
                {label}
                <ConfidenceLabel confidence={gc(key)} />
              </label>
            ))}
          </div>
          {form.decede_autre && (
            <div className="dn-field-group">
              <label>Préciser l'autre cause <ConfidenceLabel confidence={gc("decede_autre_preciser")} /></label>
              <input type="text" placeholder="Préciser..."
                value={form.decede_autre_preciser ?? ""}
                onChange={(e) => onChange("decede_autre_preciser", e.target.value)}
                style={{ borderColor: gc("decede_autre_preciser").color || undefined }} />
            </div>
          )}
        </div>
      )}

      {/* ── Si abandon ── */}
      {form.statut === "abandon" && (
        <div className="dn-sub-section">
          <div className="dn-field-group">
            <label>Moment et cause de l'abandon <ConfidenceLabel confidence={gc("abandon_moment_cause")} /></label>
            <textarea rows={4} placeholder="Préciser le moment et la cause..."
              value={form.abandon_moment_cause ?? ""}
              onChange={(e) => onChange("abandon_moment_cause", e.target.value)}
              style={{ borderColor: gc("abandon_moment_cause").color || undefined }} />
          </div>
        </div>
      )}

      <div className="dn-divider" />

      {/* ── Complications au long cours ── */}
      <div className="dn-field-group">
        <label>Complications au long cours <ConfidenceLabel confidence={gc("complications_long_cours")} /></label>
        <div className="dn-radio-group">
          {["oui","non"].map((val) => (
            <label key={val} className="dn-radio-label">
              <input type="radio" name="complications_long_cours" value={val}
                checked={form.complications_long_cours === val}
                onChange={() => onChange("complications_long_cours", val)} />
              {val === "oui" ? "Oui" : "Non"}
            </label>
          ))}
        </div>
      </div>
      {form.complications_long_cours === "oui" && (
        <div className="dn-field-group">
          <label>Préciser les complications <ConfidenceLabel confidence={gc("complications_preciser")} /></label>
          <textarea rows={4} placeholder="Décrire les complications..."
            value={form.complications_preciser ?? ""}
            onChange={(e) => onChange("complications_preciser", e.target.value)}
            style={{ borderColor: gc("complications_preciser").color || undefined }} />
        </div>
      )}

    </div>
  );
};

export default TabStatut;